import ExternalProjectService from "../../services/externalProject.service";

const state = {
    externalUserInfo: [],
    externalUserInfos: []
};

const mutations = {
    set_external_info_list(state, payload) {
        state.externalUserInfos = payload
    },
    set_external_info(state, payload) {
        state.externalUserInfo = payload;
    }
};

const actions = {
    async getExternalInfos({commit}) {
        const seras = await ExternalProjectService.getExternalInfosService();
        commit("set_external_info_list", seras);
        return seras;
    },
    async getExternalInfo({commit}, {userId, projectCode}) {
        const sera = await ExternalProjectService.getExternalInfoService(userId, projectCode)
        commit("set_external_info", sera);
        return sera;
    },
    async AddExternalInfo({dispatch}, payload) {
        const sera = await ExternalProjectService.AddExternalInfoService(payload);
        dispatch("getSeraInfos");
        return sera;
    }

};

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
